import React, { useMemo } from 'react';
import renderers from './rericos/renderers/index.js';
import { decorators } from './rericos/decorators/index.js';
import { getPluginRenderers } from './rericos/renderers/plugins/getPluginRenderers.js';
import { RicosStyles, ZIndexService } from 'ricos-styles';
import { merge } from 'lodash';
import { THEME_DEFAULTS } from './defaults.js';
import RicosNodesRenderer from './RicosNodesRenderer.js';
import { RicosContextProvider, ZIndexContextProvider, ContentTraverserContextProvider, RicosViewerContextProvider, RicosDirectionContextProvider, SpoilerContextProvider, RicosNodeContextProvider } from 'ricos-context';
import SpoilerManager from './rericos/utils/SpoilerManager.js';
import { Decorators } from './rericos/decorators/nodeViewDecorators.js';
import 'ricos-schema';
import './rericos/renderers/paragraph/paragraph.js';
import '../alignment.rtlignore-7b559f6b.js';
import '../rtl.rtlignore-32a3975e.js';
import '../indentation-f34dbac6.js';
import './rericos/renderers/consts.js';
import 'classnames';
import './rericos/utils/Anchorable.js';
import './rericos/utils/paywallSeo.js';
import 'wix-rich-content-common';
import './rericos/renderers/blockquote/blockquote.js';
import 'ricos-converters';
import './rericos/renderers/codeblock/codeblock.js';
import './rericos/renderers/heading/heading.js';
import './rericos/renderers/lists/bulletedList.js';
import '../lists-ade71bb2.js';
import './rericos/renderers/lists/orderedList.js';
import './rericos/renderers/lists/listItem.js';
import './rericos/renderers/text/text.js';
import 'ricos-common-plugins/viewer';
import './rericos/renderers/plugins/consts.js';
import './rericos/renderers/plugins/fromTypeMapper.js';
import 'ricos-content/libs/convertNodeDataToDraftNoInnerRCE';
import '../getClassNames-fdffc735.js';
import './rericos/renderers/plugins/ContainerElement.js';
import './rericos/renderers/plugins/fromExternalNode.js';
import 'ricos-content/libs/struct-converters';
import './rericos/renderers/plugins/nodeViewContainer.js';
import './components/ErrorBoundary.js';
import './rericos/render.js';
import './components/Anchor.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ContentTraverser = ({
  content,
  context,
  typeMappers,
  nodeViewRenderers,
  nodeViewDecorators,
  SpoilerViewerWrapper,
  addAnchorsPrefix
}) => {
  const { documentStyle, nodes } = content;
  const { theme, isMobile } = context;
  const themeWithDefaults = merge(
    {},
    isMobile ? THEME_DEFAULTS.mobile : THEME_DEFAULTS.desktop,
    theme
  );
  const ricosStyles = new RicosStyles();
  ricosStyles.setTheme(themeWithDefaults).setDocumentStyle(documentStyle || {});
  const spoilerManager = new SpoilerManager();
  const allRenderers = useMemo(
    () => __spreadValues(__spreadValues({}, renderers), getPluginRenderers(context, typeMappers, nodeViewRenderers, SpoilerViewerWrapper)),
    []
  );
  const allDecorators = useMemo(() => {
    return Decorators.of([...decorators, ...nodeViewDecorators], context);
  }, []);
  const ricosContext = useMemo(() => {
    const { t, locale, isMobile: isMobile2, theme: theme2, experiments, languageDir } = context;
    return {
      t,
      locale,
      isMobile: isMobile2,
      theme: theme2,
      experiments,
      languageDir
    };
  }, []);
  const zIndexService = useMemo(() => {
    return new ZIndexService(context.isMobile, context.theme.settingsStyles);
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ricosStyles.toStyleTags().map((tag, i) => React.cloneElement(tag, { key: i })), /* @__PURE__ */ React.createElement(RicosContextProvider, __spreadValues({}, ricosContext), /* @__PURE__ */ React.createElement(ZIndexContextProvider, { zIndexService }, /* @__PURE__ */ React.createElement(
    ContentTraverserContextProvider,
    {
      nodeViewDecorators: allDecorators,
      renderers: allRenderers,
      SpoilerViewerWrapper
    },
    /* @__PURE__ */ React.createElement(RicosViewerContextProvider, { contextualData: context }, /* @__PURE__ */ React.createElement(RicosDirectionContextProvider, { textDirection: context.textDirection }, /* @__PURE__ */ React.createElement(SpoilerContextProvider, { spoilerManager }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: null, parentIndex: 0 }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes, isRoot: true, addAnchorsPrefix })))))
  ))));
};

export { ContentTraverser as default };
//# sourceMappingURL=ContentTraverser.js.map
